import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Use BypassMode.CLIENT_ERRORS to bypass the global interceptor on 4xx status codes and handle the error locally
 */
export enum BypassMode {
  NONE = 'NONE',
  CLIENT_ERRORS = 'CLIENT_ERRORS',
}

export const BYPASS_ERROR_HANDLING = new HttpContextToken<BypassMode>(() => BypassMode.NONE);

export function bypassClientErrorHandling() {
  return new HttpContext().set(BYPASS_ERROR_HANDLING, BypassMode.CLIENT_ERRORS);
}
